import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-primary rounded-circle text-white d-flex justify-content-center align-items-center",
  style: {"width":"1.5em","position":"absolute","height":"1.5em","right":"1rem","top":"1rem"}
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "card-title text-uppercase" }
const _hoisted_4 = {
  key: 0,
  class: "ml-2",
  style: {"font-size":"1em","color":"green"}
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-6 col-md-12 text-dark text-nowrap" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { style: {"font-size":"1.5em"} }
const _hoisted_9 = {
  class: "display-4",
  style: {"font-size":"2.5rem"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "/year", -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_12 = {
  class: "display-4 ml-4 text-muted",
  style: {"font-size":"1.6rem"}
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { style: {"font-size":"1.5em"} }
const _hoisted_16 = {
  class: "display-4",
  style: {"font-size":"2.5rem"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "/month", -1 /* HOISTED */)
const _hoisted_18 = { class: "col-6 col-md-12 small mt-md-2" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "d-flex align-items-center" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Check = _resolveComponent("Check")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card plan-card", {'border border-primary': $props.is_active}])
  }, [
    ($props.is_active)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Check)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, [
        _createTextVNode(_toDisplayString($props.plan.title) + " ", 1 /* TEXT */),
        ($props.billing_cycle === 'Yearly' && $props.plan.apply_discount)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($props.plan.discount) + "% Off ", 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          ($props.billing_cycle === 'Yearly')
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString($options.currency_symbol), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_9, _toDisplayString($options.get_price($props.plan)), 1 /* TEXT */),
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("span", _hoisted_12, [
                  ($props.plan.apply_discount)
                    ? (_openBlock(), _createElementBlock("s", _hoisted_13, _toDisplayString($options.get_non_dicounted_price($props.plan)), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString($options.currency_symbol), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_16, _toDisplayString($options.get_price($props.plan)), 1 /* TEXT */),
                _hoisted_17
              ]))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_Check, { class: "mr-2 mt-1" }),
            _createTextVNode(" " + _toDisplayString($props.plan.users) + " users ", 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_Check, { class: "mr-2 mt-1" }),
            _createTextVNode(" " + _toDisplayString($props.plan.space) + "GB of storage ", 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_Check, { class: "mr-2 mt-1" }),
            _createTextVNode(" " + _toDisplayString($props.plan.emails) + " emails per month ", 1 /* TEXT */)
          ])
        ])
      ])
    ])
  ], 2 /* CLASS */))
}